function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.3571 3H13.2858C13.1153 3.00004 12.9518 3.0678 12.8313 3.18837L3.18855 12.831C2.93735 13.0819 2.93712 13.4889 3.18806 13.7401C3.18821 13.7402 3.1884 13.7404 3.18855 13.7406L10.2599 20.8118C10.5109 21.0627 10.9179 21.0627 11.1689 20.8118L20.8116 11.1692C20.9324 11.0485 21.0001 10.8848 21 10.7141V3.64285C21 3.28781 20.7122 3 20.3571 3ZM16.5 8.78556C15.79 8.78556 15.2143 8.20994 15.2143 7.49989C15.2143 6.78984 15.79 6.21422 16.5 6.21422C17.2101 6.21422 17.7857 6.78984 17.7857 7.49989C17.7857 8.20994 17.2101 8.78556 16.5 8.78556Z",
  fill: "#0F2E43"
});

var SvgSaleInfo = function SvgSaleInfo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSaleInfo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sale-info.ef6ea960.svg";
export { ForwardRef as ReactComponent };